import { UserType } from 'api';
import { SettingsType } from 'common';
import { AppRootStateType } from 'state/store';

export const usersSelect = (state: AppRootStateType): UserType[] => state.users.users;
export const certainUserSelect = (state: AppRootStateType): UserType | undefined =>
  state.users.certainUser;
export const usersSettingsSelect = (state: AppRootStateType): SettingsType =>
  state.users.userSettings;
